<div id="dk-label" class="text-left">
  <span class="label" [class.disabled]="disabled"
    >{{ label | translate }}
    @if (labelDescription) {
      <span class="label-description">{{ labelDescription | translate }}</span>
    }
  </span>
  <span *ngIf="isRequired && !disabled" class="required-field-star">*</span>
</div>
